module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', [_vm._v("Welcome!")]), _vm._v(" "), (!this.$store.getters.isUserLoggedIn) ? _c('p', [_vm._v("In order to use this service, please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" first.")], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.isUserLoggedIn) ? _c('p', [_vm._v("You are logged in, " + _vm._s(this.$store.getters.user.name) + ".")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(this.$store.getters.customText)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Statistics\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.stats.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.stats.errorMessage
    }
  }), _vm._v(" "), (_vm.stats.data) ? _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Calls")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.calls))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Callsigns")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.callSigns))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("News")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.news))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Rubrics")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.rubrics))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Transmitters")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTransmitter))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Nodes")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statNodes))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Users")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.users))])])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Digital Pager Network freeband.digital")]), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://freeband.digital",
      "target": "_blank"
    }
  }, [_vm._v("freeband.digital")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f896b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 618
// module chunks = 1